import emblemWhite from "@/assets/dpnox-emblem-white.png";
import logoWhite from "@/assets/dpnox-logo-white.png";
import logoNavy from "@/assets/dpnox-logo-navy.png";

export const BRAND = {
  name: "DPNox",
  tagline: "Emissions Solutions",
  email: "recambios@dieselpaco.com",
  phone: "937889048",
  phoneDisplay: "937 889 048",
  whatsapp: "34937889048", // internacional para wa.me (España +34)
  dieselPacoUrl: "https://www.dieselpaco.com",
  emblem: emblemWhite,
  logoFull: logoWhite,
  logoNavy: logoNavy,
  hero:
    "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  legacyImg:
    "https://images.unsplash.com/photo-1676018366904-c083ed678e60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const waLink = (text = "") =>
  `https://wa.me/${BRAND.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
